export const MAP_CONTAINER = "map-container";
export const DATA_MAP_READY = "data-map-ready";
export const VIRTUAL_LIST_WRAPPER = "virtual-list-wrapper";
export const STORE_LIST_LOADER = "store-list-loader";
export const DATA_STORES_COUNT = "data-stores-count";
export const DATA_ECCO_STORES_COUNT = "data-ecco-stores-count";
export const DATA_MARKERS_ON_MAP_COUNT = "data-markers-on-map-count";
export const PARTNER_STORES_SWITCH = "partner-stores-switch";
export const STORE = "store";
export const SEARCH = "store-search";
export const SEARCH_SUGGESTION = "store-search-suggestion";
export const STORE_ADDRESS = "store-address";
export const MAP_TAB_SWITCH_LIST = "map-tab-switch-list";
export const MAP_TAB_SWITCH_MAP = "map-tab-switch-map";
export const FILTER_DROPDOWN = "filter-dropdown";

export const SLOW_TIMEOUT_MODIFIER = 2;

export const DISABLED_RULES = {
    "document-title": { enabled: false },
    "meta-viewport": { enabled: false },
    "color-contrast": { enabled: false },
    region: { enabled: false },
    "svg-img-alt": { enabled: false },
    "heading-order": { enabled: false },
    "frame-title": { enabled: false },
};
